export const filterOrdersByExchange = (data, activeTabList) => {
    switch (activeTabList) {
        case "NFO":
            return data.filter(
                (item) =>
                    item.exchange === "EQUITY" ||
                    item.exchange === "EQUITY(INDEX)"
            );
        case "MCX":
            return data.filter((item) => item.exchange === "MCX");
        case "CRYPTO":
            return data.filter((item) => item.exchange === "CRYPTO");
        case "FX":
            return data.filter((item) => item.exchange === "FOREX");
        case "US":
            return data.filter((item) => item.exchange === "US");
        default:
            return data;
    }
};

export const findMarketMatch = (marketData, token) => {
    return marketData?.find(
        (m) => String(m.symbolToken) === String(token)
    );
};

export const findFetchMatch = (fetchData, token) => {
    return fetchData?.data?.fetched?.find(
        (f) => String(f.symbolToken) === String(token)
    );
};

export const extractDateFromSymbol = (tradingSymbol) => {
    const match = tradingSymbol.match(/\d{1,2}[A-Z]{3}\d{2}/);
    return match ? match[0] : null;
};

export const calculateTotals = (orders, marketData) => {
    let totalInvested = 0;
    let currentValue = 0;

    orders.forEach(order => {
        const invested = parseFloat(order.price) * parseInt(order.qty);
        totalInvested += invested;

        const marketMatch = findMarketMatch(marketData, order.token);
        if (marketMatch) {
            currentValue += parseFloat(marketMatch.ltp) * parseInt(order.qty);
        }
    });

    const totalProfit = currentValue - totalInvested;

    return {
        totalInvested,
        currentValue,
        totalProfit
    };
};